import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Quotations } from 'Models/ResponseModels'

interface IState {
  isAscending: boolean
  isComprehensive: boolean
  isIndividual: boolean
  pucCertificate: boolean
  inspectionRequired: boolean
  fuelType: string
  idv: number
  trailer_idv?: string
  selectedQuote?: Quotations
  isBreakIn: boolean
  paOwnerReason?: string
}

const initialState: IState = {
  isAscending: true,
  isComprehensive: true,
  isIndividual: true,
  pucCertificate: true,
  inspectionRequired: false,
  fuelType: '',
  idv: 0,
  isBreakIn: false,
}

const quotationPageDetails = createSlice({
  name: 'quotationDetails',
  initialState: initialState,
  reducers: {
    updateAscending: (
      state,
      action: PayloadAction<{
        isAscending: boolean
      }>,
    ) => {
      const { isAscending } = action.payload
      state.isAscending = isAscending
    },
    updatePolicyType: (
      state,
      action: PayloadAction<{
        isComprehensive: boolean
      }>,
    ) => {
      const { isComprehensive } = action.payload
      state.isComprehensive = isComprehensive
    },
    updateOwnedBy: (
      state,
      action: PayloadAction<{
        isIndividual: boolean
      }>,
    ) => {
      const { isIndividual } = action.payload
      state.isIndividual = isIndividual
    },
    updateCertificateStatus: (
      state,
      action: PayloadAction<{
        pucCertificate: boolean
      }>,
    ) => {
      const { pucCertificate } = action.payload
      state.pucCertificate = pucCertificate
    },
    updateFuelType: (
      state,
      action: PayloadAction<{
        fuelType: string
      }>,
    ) => {
      const { fuelType } = action.payload
      state.fuelType = fuelType
    },
    updateIDV: (
      state,
      action: PayloadAction<{
        idv: number
      }>,
    ) => {
      const { idv } = action.payload
      state.idv = idv
    },
    updateTrailerIDV: (
      state,
      action: PayloadAction<{
        trailer_idv: string
      }>,
    ) => {
      const { trailer_idv } = action.payload
      state.trailer_idv = trailer_idv
    },
    updatePaOwnerReason: (
      state,
      action: PayloadAction<{
        paOwnerReason: string
      }>,
    ) => {
      const { paOwnerReason } = action.payload
      state.paOwnerReason = paOwnerReason
    },
    updateInspectionRequired: (
      state,
      action: PayloadAction<{
        inspectionRequired: boolean
      }>,
    ) => {
      const { inspectionRequired } = action.payload
      state.inspectionRequired = inspectionRequired
    },
    updateSelectedQuote: (
      state,
      action: PayloadAction<{
        selectedQuote: Quotations
      }>,
    ) => {
      const { selectedQuote } = action.payload
      state.selectedQuote = selectedQuote
    },
    resetQuotation: () => initialState,
  },
})

const { reducer } = quotationPageDetails

const {
  updateAscending,
  updatePolicyType,
  updateOwnedBy,
  updateCertificateStatus,
  updateFuelType,
  updateIDV,
  updatePaOwnerReason,
  updateSelectedQuote,
  updateInspectionRequired,
  updateTrailerIDV,
  resetQuotation,
} = quotationPageDetails.actions

export {
  updateAscending,
  updateOwnedBy,
  updatePolicyType,
  updateCertificateStatus,
  updateSelectedQuote,
  updateFuelType,
  updateIDV,
  updateInspectionRequired,
  updateTrailerIDV,
  updatePaOwnerReason,
  resetQuotation,
  reducer as quotationsReducer,
}
